import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkflowModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkflowModel._instance == null) WorkflowModel._instance = new WorkflowModel(authManager);
        return WorkflowModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/workflows');

        this.entityName = 'core.Workflow';
        this.privileges = {
            create: [["adminWorkflow"]],
            read: [["#everyone"]],
            update: [["adminWorkflow"]],
            delete: [["adminWorkflow"]],
        };

        this.label = 'Workflow';
        this.setLabel = 'Workflow';

        this.browser = {
            name: 'default-core-workflow-browser',
            moduleName: 'default-core-workflow-browser',
            moduleTitle: 'Workflow',
            moduleStateSlotName: 'default-core-workflow-browser',
        };

        this.editor = {
            name: 'default-core-workflow-editor',
            moduleName: 'default-core-workflow-editor',
            moduleTitle: 'Workflow',
            moduleStateSlotName: 'default-core-workflow-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
